import { selectorFamily } from 'recoil';
import { featureFlagsAtom } from '../atom';
export function createFeatureFlagSelector() {
    return selectorFamily({
        key: 'common/featureFlags/featureFlagSelector',
        get: (key) => ({ get }) => {
            const flags = get(featureFlagsAtom);
            return flags[key];
        },
    });
}
export const featureFlagSelector = createFeatureFlagSelector();
